import { DataEntity_Detail_01_Interface } from './DataEntity_Detail_01_Interface';

export interface DataEntity_Main_01_Interface {
  id:number,
  calibration_id:number,
  reference_Value:number,
  set_Value:number,
  sample_Indication_Max:number,
  sample_Indication_Min:number,
  reference_Value_Center_Max:number,
  reference_Value_Center_Min: number,
  filename:string,
  uncertainty:string,
  observation_visible:boolean,
  detail:Array<DataEntity_Detail_01_Interface>
}

export function Empty_DataEntity_Main_01_Interface():DataEntity_Main_01_Interface{
    return{
        id:0,
        calibration_id:0,
        reference_Value:0,
        set_Value:0,
        sample_Indication_Max:0,
        sample_Indication_Min:0,
        reference_Value_Center_Max:0,
        reference_Value_Center_Min: 0,
        filename:'',
        uncertainty: '',
        observation_visible:false,
        detail:[]
    }
  }
